import { eventDispatcher, TOPICS } from "@origin-digital/event-dispatcher";
import { dapiFetch } from "@origin-digital/daxi";
import { logger } from "@origin-digital/reporting-client";
import merge from "lodash/merge";
import { IShowModalCta } from "@origin-digital/event-dispatcher/src/topics.types";
import content from "../content.json";
import { UserInfo } from "./customerType";

export type NativeModalContent = {
  disableClose: boolean;
  title: string;
  body: string;
  ctaLink: IShowModalCta;
};

type ModalContent = NativeModalContent;

export const forceUserIntervention = () => {
  logger.warn(
    `[migration-experience] Forcing user to close app as they have invalid app state.`
  );
  const modalContent = getModalContent();

  try {
    eventDispatcher.dispatch({
      topic: TOPICS.MODAL_OPEN,
      payload: modalContent,
    });
    eventDispatcher.dispatch({
      topic: TOPICS.HTTP_REQ_ERROR,
      payload: {
        status: 401,
        message: "JWT needs refreshing. User was migrated to Kraken.",
        req: "Please try logging out and logging back in",
      },
    });
  } catch (e) {
    logger.warn(
      `[migration-experience] Forcing user to close app as they have invalid app state. Failed with:`,
      e
    );
  }
};

export const getModalContent = (): ModalContent => {
  const button = {
    ctaLink: {
      type: "url",
      text: content.showModal.native.ctaLink.text,
      action: content.showModal.native.ctaLink.text,
    },
  } as const;

  return merge({ disableClose: true }, button, content.showModal.native);
};

export const getUserInfo = async (): Promise<UserInfo | undefined> => {
  const url = `/api/user/v3/user/type`;
  try {
    const response = await dapiFetch<UserInfo>(url, {
      method: "GET",
      authorization: "jwt",
    });

    return response.data;
  } catch (e) {
    logger.error("[@od/bootloader]: getUserInfo() failure", e);
    return undefined;
  }
};
